import { Component, inject, OnInit } from '@angular/core';
import { BaseCompetenze } from '../../model/iscritti-data';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { QuoteService } from '../../services/quote.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-gestione-competenze',
  templateUrl: './gestione-competenze.component.html',
  styleUrl: './gestione-competenze.component.scss'
})
export class GestioneCompetenzeComponent implements OnInit{

  //Services
  private route = inject(ActivatedRoute);
  private quote_service = inject(QuoteService);
  private message_service = inject(MessageService);


  visible: boolean = false;
  titleDiaolg: string = '';
  bodyDiaolog: boolean = false;
  buttonDialog: string = '';

  competenzeList: BaseCompetenze[] = [];

  competenzaForm = new FormGroup({
    anno: new FormControl<number|null>(null, Validators.required),
    quota: new FormControl<number|null>(null, Validators.required),
    quotaRidotta: new FormControl<number|null>(null, Validators.required),
    percentualeRiduzione: new FormControl<number|null>(null, Validators.required),
    anniRiduzione: new FormControl<number|null>(null, Validators.required),
    dataMorosita: new FormControl<Date|null>(null, Validators.required),
    speseAmministrative: new FormControl<number|null>(null, Validators.required),
    speseApplicate: new FormControl<boolean|null>(null, Validators.required)
  });

  ngOnInit(): void {
    this.initialHandler();
  }

  private initialHandler(){
    this.competenzeList = this.route.snapshot.data['baseCompetenzeList'];
  }

  private buildDate(data_in: Date){
    const day = String(data_in.getDate()).padStart(2, '0');
    const month = String(data_in.getMonth() + 1).padStart(2, '0');
    const year = String(data_in.getFullYear());

    const data = `${year}-${month}-${day}`;

    return data;
  }

  showDialogModifica(index: number){

    this.titleDiaolg = 'Modifica Competenza';
    this.bodyDiaolog = false;

    const element: BaseCompetenze = this.competenzeList[index];

    this.competenzaForm.patchValue({
      anno: element.anno,
      quota: element.quota,
      quotaRidotta: element.quotaRidotta,
      percentualeRiduzione: element.percentualeRiduzione,
      anniRiduzione: element.anniRiduzione,
      dataMorosita: element.dataMorosita ? new Date(element.dataMorosita) : null,
      speseAmministrative: element.speseAmministrative,
      speseApplicate: element.speseApplicate
    });

    this.visible = true;

  }

  closeDialogModifica(){
    this.competenzaForm.reset();
    this.visible = false;
  }

  generaCompetenza(){

    this.titleDiaolg = 'Genera Competenza';
    this.bodyDiaolog = true;

    this.competenzaForm.patchValue({
      anno: null,
      quota: null,
      quotaRidotta: 0,
      percentualeRiduzione: null,
      anniRiduzione: null,
      dataMorosita: null,
      speseAmministrative: null,
      speseApplicate: false
    });

    this.visible = true;
  }

  salvaModifica(){
    const values = this.competenzaForm.value;

    const data: BaseCompetenze = {
      anno: values.anno!,
      quota: values.quota!,
      quotaRidotta: values.quotaRidotta!,
      percentualeRiduzione: values.percentualeRiduzione!,
      anniRiduzione: values.anniRiduzione!,
      dataMorosita: this.buildDate(values.dataMorosita!),
      speseAmministrative: values.speseAmministrative!,
      speseApplicate: values.speseApplicate!
    };

    this.quote_service.modificaBaseCompetenza(data).subscribe({
      next: (result: BaseCompetenze[]) => {
        this.competenzeList = result;
      },
      complete: () => {
        this.competenzaForm.reset();
        this.visible = false;
        this.message_service.add({ severity: 'success', summary: `Operazione completata`, detail: `Competenza modificata con successo.` });
      },
      error: (err) => {
        this.visible = false;
        this.message_service.add({ severity: 'error', summary: `Operazione interrotta`, detail: err.error });
      }
    });

  }

  genera(){

    const values = this.competenzaForm.value;

    const data: BaseCompetenze = {
      anno: values.anno!,
      quota: values.quota!,
      quotaRidotta: values.quotaRidotta!,
      percentualeRiduzione: values.percentualeRiduzione!,
      anniRiduzione: values.anniRiduzione!,
      dataMorosita: this.buildDate(values.dataMorosita!),
      speseAmministrative: values.speseAmministrative!,
      speseApplicate: values.speseApplicate!
    };

    this.quote_service.generaBaseCompetenza(data).subscribe({
      next: (result: BaseCompetenze[]) => {
        this.competenzeList = result;
      },
      complete: () => {
        this.competenzaForm.reset();
        this.visible = false;
        this.message_service.add({ severity: 'success', summary: `Operazione completata`, detail: `Competenza generata con successo.` });
      },
      error: (err) => {
        this.visible = false;
        this.message_service.add({ severity: 'error', summary: `Operazione interrotta`, detail: err.error });
      }
    });

  }

}
